module.exports = __webpack_public_path__ + "img/02s_marketing.1f7206f4.jpg";